<template>
  <ApiSimpleSearch
      :url=         "url"
      :cardsMap=    "cardsMap"
      :buttonProps= "buttonProps"
  >
    <v-col cols="12" class="pb-0">
      <v-text-field
          hide-details
          clearable
          outlined
          reverse
          dense
          :label=           "$t('field.serialNumber')"
          :rules=           "rules"
          v-model=          "serialNumber"
          :loading=         "buttonProps.loading"
          :disabled=        "buttonProps.loading"
          @keypress.enter=  "buttonProps.click"
      />
    </v-col>
    <v-col cols="12" class="pb-0">
      <v-text-field
          hide-details
          clearable
          outlined
          reverse
          dense
          :label=           "$t('field.chassisNumber')"
          :rules=           "rules"
          v-model=          "chassisNumber"
          :loading=         "buttonProps.loading"
          :disabled=        "buttonProps.loading"
          @keypress.enter=  "buttonProps.click"
      />
    </v-col>
  </ApiSimpleSearch>
</template>

<script>
  import ApiSimpleSearch from '../components/ApiSimpleSearch'

  export default {
    name:       'Busses',
    components: { ApiSimpleSearch },
    data: function() {
      return {
        rules:        [ value => !value || this.validateInput() ],
        serialNumber: '',
        chassisNumber: '',
        buttonProps: {
          click:    ()=>{},
          loading:  false,
          disabled: true
        },
        cardsMap: [
          { name: 'basicInfo',    fields: 'SERNUM,YHV_SHILDA,YHV_MANOA'.split(',') },
          { name: 'dates',        fields: 'WARDATE,WARDATE1,WARDATE2,RDP_WARRMADUZMNF,RDP_WARRMADUZIMP'.split(',') },
          { name: 'model',        fields: 'YHV_DGMSHERUTNAME,YHV_ENGINEMNFDES,YHV_GEARBOXNAME,YHV_AIRCONDDES,YHV_AIRPOLLUTDES,YHV_CARPURPOSEDES'.split(',') },
          { name: 'techDetails',  fields: 'RDP_FRONTAXLEDES,RDP_BACKAXLEDES,RDP_COOLINGFANDES'.split(',') },
          { name: 'services',     fields: 'RDP_LOANNUM,RDP_COSTCTREEDES,RDP_SNAME,RDP_SNAME2'.split(',') }
        ]
      }
    },
    methods: {
      url() {
        if (this.chassisNumber) {
          return `/apiv1/busses?YHV_SHILDA=${this.chassisNumber}`;
        }

        return `/apiv1/busses?SERNUMBER=${this.serialNumber}`
      },
      validateInput() {
        if (this.serialNumber) {
          return !!(this.serialNumber || '').match(/^\d+$/)
        }
        
        return !!(this.chassisNumber || '').match(/^[A-HJ-NPR-Za-hj-npr-z\d]{8}[\dX][A-HJ-NPR-Za-hj-npr-z\d]{2}\d{6}$/)
      }
    },
    watch:{
      "serialNumber": {
        handler: function() {
          this.buttonProps.disabled = !this.validateInput()
        },
        immediate: true
      },
      "chassisNumber": {
        handler: function() {
          this.buttonProps.disabled = !this.validateInput()
        },
        immediate: true
      },
    }
  }
</script>
